import React from 'react';
import { FormApi, SubmissionErrors } from 'final-form';
import arrayMutators from 'final-form-arrays';
import * as Yup from 'yup';
import { createRffSchema } from '../../lib/ReactFinalForm';
import { UserProfile } from '../../services/generated/app-api';
import Form from '../Form';

export const userDetailsValidationSchema = Yup.object().shape({
    givenName: Yup.string().required().label('First Name'),
    familyName: Yup.string().required().label('Last Name'),
    emailAddress: Yup.string().required().label('Email Address'),
    password: Yup.string()
        .trim()
        .transform((value) => (value === '' ? undefined : value))
        .optional()
        .min(6)
        .label('Password'),
    passwordConfirmation: Yup.string()
        .trim()
        .transform((value) => (value === '' ? undefined : value))
        .optional()
        // .test('is-incorrect', 'Password confirmation is not equal to password', function (value) {
        //     const values = this.parent as UserDetailsFormValues;
        //     return values && value ? value === values.password : true;
        // })
        .min(6)
        .label('Password confirmation'),
});
export type UserDetailsFormValues = {
    givenName: string;
    familyName: string;
    emailAddress: string;
    password?: string;
    passwordConfirmation?: string;
};
export const initialUserDetailsFormValues: UserDetailsFormValues = {
    givenName: '',
    familyName: '',
    emailAddress: '',
};
export const userDetailsFormValuesFormSchema = createRffSchema<UserDetailsFormValues>(initialUserDetailsFormValues, userDetailsValidationSchema);
const mapUserToFormValues = (user: UserProfile): UserDetailsFormValues => ({
    givenName: user?.firstName || '',
    familyName: user?.lastName || '',
    emailAddress: user?.email || '',
});

interface UserDetailsFromProps {
    user: UserProfile;
    onSubmit: (
        values: Partial<UserProfile> & { password?: string; passwordConfirmation?: string },
        form: FormApi<UserDetailsFormValues>
    ) => SubmissionErrors | Promise<SubmissionErrors | undefined> | undefined | void;
}

const UserDetailsFrom: React.FC<React.PropsWithChildren<UserDetailsFromProps>> = ({ user, children, onSubmit }) => (
    <Form
        onSubmit={(values: UserDetailsFormValues, form) => {
            if (values.password || values.passwordConfirmation) {
                if (values.password !== values.passwordConfirmation) {
                    return {
                        passwordConfirmation: 'Password confirmation is not equal to password',
                    };
                }
            }
            const profile = {
                ...user,
                firstName: values.givenName,
                lastName: values.familyName,
                email: values.emailAddress,
                password: values.password || undefined,
                passwordConfirmation: values.passwordConfirmation || undefined,
            };
            return onSubmit(profile, form);
        }}
        initialValues={mapUserToFormValues(user)}
        validate={userDetailsFormValuesFormSchema.validate}
        subscription={{}}
        mutators={{ ...arrayMutators }}
        render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} noValidate>
                {children}
            </form>
        )}
    />
);

export default UserDetailsFrom;
